module.exports = __webpack_public_path__ + "media/application/images/svgs/crosshair-c06123d23a313230d7b2fd5ed1d40909.svg";